module.exports = __webpack_public_path__ + "media/assets/services_manager/help-0322a44a8c1f22271aba382436daa051c1533eafddac1ee88c3c1d5d75f99a58.svg";